<template>
	<div @click="$emit('click', $event)" :style="`width: 100%; text-align: ${item.alignment}`">
		<img :src="logoUrl" :style="`width:${item.width}px`">
	</div>
</template>

<script>
	import RendererMixin from "@/modules/forms/v2/schema/RendererMixin";
	import { formLogo, invoiceBranding } from '@moxie/branding';

	export default {
		name: 'ImageBlock',

		props: ['accountLogo','item','invoice'],

		mixins: [RendererMixin],

		components: {},

		data: function() {
			return {};
		},

		mounted() {},

		beforeDestroy() {},

		methods: {},

		computed: {
			logoUrl: function() {
				const branding = invoiceBranding(this.invoice.invoiceTemplate);
				return formLogo(branding, this.accountLogo, branding && branding.colors.background, true, this.item.logoVariant);
			},
		},
	};
</script>

<style scoped lang="scss"></style>
